export const convertPaymentType = (text) => {

    switch (text) {
        case '0': return 'เงินสด'
        case '30': return 'เครดิต 30 วัน'
        case '45': return 'เครดิต 45 วัน'
        case '60': return 'เครดิต 60 วัน'
        default: return 'NA'
    }
}

export const convertTransactionType = (text) => {

    switch (text) {
        case 'IN': return 'รับเข้า'
        case 'TRANSIN': return 'โอนเข้า'
        case 'TRANSOUT': return 'โอนออก'
        case 'ADJUSTIN': return 'ปรับลด'
        case 'ADJUSTOUT': return 'ปรับเพิ่ม'
        default: return 'ขาย'
    }
}

export const convertDocType = (text) => {

    switch (text) {
        case 'INVOICE': return 'ใบแจ้งหนี้'
        case 'TAXINVOICE': return 'ใบกำกับภาษี'
        case 'RECEIPT': return 'ใบเสร็จรับเงิน'
        case 'SHIPPINGNOTE': return 'ใบส่งสินค้า'
        case 'BILLINGSLIP': return 'ใบวางบิล'
        case 'PRODUCTTRANSFERSLIP': return 'ใบโอนสินค้า'
        case 'PRODUCTRECEIPTSLIP': return 'ใบรับสินค้า'
        default: return 'เช็ค'
    }
}

export const convertDocTypeLabel = (text) => {

    switch (text) {
        case 'INVOICE': return { key: 'INVOICE', th: 'ใบแจ้งหนี้', en: 'INVOICE' }
        case 'TAXINVOICE': return { key: 'TAX INVOICE', th: 'ใบกำกับภาษี', en: 'TAX INVOICE' }
        case 'RECEIPT': return { key: 'RECEIPT', th: 'ใบเสร็จรับเงิน', en: 'RECEIPT' }
        case 'SHIPPINGNOTE': return { key: 'SHIPPING NOTE', th: 'ใบส่งสินค้า', en: 'SHIPPING NOTE' }
        case 'BILLINGSLIP': return { key: 'BILLING SLIP', th: 'ใบวางบิล', en: 'BILLING SLIP' }
        case 'PRODUCTTRANSFERSLIP': return { key: 'PRODUCT TRANSFER SLIP', th: 'ใบโอนสินค้า', en: 'PRODUCT TRANSFER SLIP' }
        case 'PRODUCTRECEIPTSLIP': return { key: 'PRODUCT RECEIVE SLIP', th: 'ใบรับสินค้า', en: 'PRODUCT RECEIVE SLIP' }
        default: return { key: 'cheque', th: 'เช็ค', en: 'cheque' }
    }
}

export const backGroundDocType = (text) => {

    switch (text) {
        case 'INVOICE': return '#1677ff17'
        case 'TAXINVOICE': return '#ff76db17'
        case 'RECEIPT': return '#4dff0717'
        case 'SHIPPINGNOTE': return '#ffa80017'
        case 'BILLINGSLIP': return '#9354ff17'
        // case 'PRODUCTTRANSFERSLIP': return 'ใบโอนสินค้า'
        // case 'PRODUCTRECEIPTSLIP': return 'ใบรับสินค้า'
        default: return '#FAFAFA'
    }
}

export const formatPhone = (text) => {
    return `${text.substr(0, 3)}-${text.substr(3, 3)}-${text.substr(6, 4)}`
}